import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useStyles } from "../reviewUtils";
import _, { max, set } from "lodash";
import {
  Paper,
  Tooltip,
  Stack,
  Typography,
  Pagination,
  IconButton,
  Divider,
  ToggleButton,
  Menu,
  MenuItem,
  Button,
  Link,
  FormControl,
  InputLabel,
  Select,
  Box,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Chip as MuiChip,
  DialogActions,
  ListSubheader,
  Card,
  useTheme,
} from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SettingsIcon from '@mui/icons-material/Settings';
import SmartToyIcon from "@mui/icons-material/SmartToy";
import { TopicChip as Chip, TopicChip } from "../../topicChip";
import ReviewListFilters from "./reviewListFilter";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ReviewItem, DropdownMenu, ReviewSearch } from "../reviewUtils";
import ReviewModal from "../reviewModal";
import { Marker } from "react-mark.js";
import { useDispatch, useSelector } from "react-redux";
import { createFilter } from "react-search-input";
import {
  fetchInternalLocations,
  locationsSelector,
} from "../../../../../store/slices/location";
import {
  fetchReviews,
  fetchSimilarReviews,
  getSimilarReviews,
  reviewsSelector,
  triggerDeleteExampleReview,
  triggerDeleteInternalReview,
  triggerSaveExampleReview,
} from "../../../../../store/slices/reviews";
import {
  fetchIssueList,
  fetchSuggestionList,
  pipelinesSelector,
  triggerCreateIssue,
  triggerDeleteIssue,
  triggerUpdateIssue,
} from "../../../../../store/slices/pipelines";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CreateIssue from "./createIssue";
import MoreDetails from "./moreDetails";
import { useAuth0 } from "@auth0/auth0-react";
import IssueEditDetails from "./issueEditDetails";
import { convertArrayToDictionary, getSourceIcon } from "../../../../../common/utils";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import moment from "moment";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';

const initialReviewFilter = {
  hideResponse: false,
  hideNoText: false,
  hideDoNotRespond: false,
  responseType: 1,
  sentiment: [],
  starRating: [],
  sortOrder: "By Review Date",
  sortOrdertype: "desc",
  isChangeDefault: false,
  withText: true,
  noText: false,
  noResponse: false,
  hasResponse: false,
  hasResponse: false,
  awaitingResponse: false,
  noResponseNecessary: false,
  selectedReviewId: null,
  dateSort: true,
  positive: false,
  negative: false,
  topicFilter: [],
  topicFilterType: 0,
  ratingSort: false,
  sortDir: "desc",
  withoutTopics: false,
  hasIssues: false,
};
const bindTooltipData = (a, topicDetails) => {
  const filteredData = topicDetails ? topicDetails[a.topic + ':' + a.sentiment] : {}
  let text = ''
  if (filteredData) {
    text = <Stack>
      <Typography variant='caption'>Sentiment: {filteredData?.sentiment?.split(":")[1]}</Typography>
      <Typography variant='caption'>Strength: {filteredData?.strength}</Typography>
      <div>
        <Typography variant='caption'>Phrases: </Typography>
        {_.map(JSON.parse(filteredData?.phrasesString), it => <li>{it}</li>)}
      </div>
      <Stack>
        <Typography variant='caption'>Explanation: </Typography>
        <Typography variant='caption'>{filteredData?.explanation}</Typography>
      </Stack>
    </Stack>
  }
  return text
}
const bindTopics = (review, singleSelectedReview, topicDetails) => {

  return _.map(review?.topics, (a, index) =>
    a.topic !== "" ? (
      <Tooltip arrow disableInteractive title={singleSelectedReview?.reviewId === review?.reviewId ? bindTooltipData(a, topicDetails) : null}>
        <span>
          <TopicChip
            className={
              a?.sentiment === "Positive" ? "positive-chip" : "negative-chip"
            }
            key={index}
            //  color={a?.sentiment == "Positive" ? "success" : "error"}
            label={a?.topic}
          />
        </span>
      </Tooltip>
    ) : (
      ""
    )
  );
};
const bindfinalData = (data, singleSelectedReview, topicDetails, locationDic) => {
  return _.map(_.cloneDeep(data), (it, index) => {
    const topicData = _.map(it?.topicData?.split("|"), (ob) => {
      const [topic, sentiment] = ob?.split(":");
      return { topic, sentiment };
    });
    it["number"] = index + 1;
    it["topics"] = topicData;
    it["locationName"] = locationDic[it?.locationId]?.name;
    it["topicElement"] = bindTopics(it, singleSelectedReview, topicDetails);
    return it;
  });
};
const Index = ({
  isSentiment,
  isPrompt,
  isPipeline,
  data,
  startDate = null,
  endDate = null,
  selectedLocation = "all",
  selectedCompany = null,
  singleSelectFunction = null,
  filters = true,
  isMultiple,
  selectedReviewIds,
  setSelectedReviewIds,
  selectedReviewText,
  setSelectedReviewText,
  setFinalReviews,
  enableSelectAll = false,
  reviewHeight,
  setSelectedReview,
  selectededReview,
}) => {
  const theme = useTheme();
  const { user } = useAuth0();
  const userId = useMemo(() => _.replace(user?.['rightresponse.ai/roles']?.roles[1], 'userid:', ''))
  const classes = useStyles();
  const { similarReviews } = useSelector(reviewsSelector)
  const duspatch = useDispatch();
  const dispatch = useDispatch();
  const emptyClick = () => { };
  const [reviewsPage, setReviewsPage] = useState(1);
  const [noOfPages, setPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [singleSelectedReview, setSingleSelectedReview] = useState(null);
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [focusedReview, setFocusedReview] = useState({});
  const [openCollapse, setOpenCollapse] = useState(false);
  const [sortedReviews, setSortedReviews] = useState([]);
  const [selectedShowType, setSelectedShowType] = useState("database");
  const [reviewsNumberSelection, seReviewsNumberSelection] = useState("none");
  const { suggestionList } = useSelector(pipelinesSelector);
  const { issueList, locations } = useSelector(locationsSelector)
  const [openIssueModal, setOpenIssueModal] = useState(false);
  const [issueReview, setIssueReview] = useState({});
  const [issueDescription, setIssueDescription] = useState(null);
  const [issueData, setIssueData] = useState(null);
  const [issueListId, setIssueListId] = useState(null);
  const [anchorElMenu, setAnchorElMenu] = React.useState(null);
  const [menuReview, setMenuReview] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);
  const [openDeleteWarning, setOpenDeleteWarning] = useState(false);
  const open = Boolean(anchorElMenu);
  const [openMoreDetails, setOpenMoreDetails] = useState(false);
  const [issueListEdit, setIssueListEdit] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [anchorEl3, setAnchorEl3] = useState(null);
  const [countValue, setCountValue] = useState(null);
  const [tempReviewsText, setTempReviewsText] = useState([]);
  const [tempReviewIds, setTempReviewIds] = useState([]);

  const handleClickMenu = (event, review) => {
    setAnchorElMenu(event.currentTarget);
    setMenuReview(review);
    setFocusedReview(review)
    event.stopPropagation();
  };
  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };
  const editIssue = () => {
    setEditMode(true);
    setOpenIssueModal(true);
  };
  //========Reviews Data===========//

  const topicDetails = useMemo(() => {
    return convertArrayToDictionary(similarReviews?.sentiments, 'sentiment')
  }, [similarReviews?.sentiments
  ])
  const locationDic = useMemo(() => {
    return convertArrayToDictionary(locations, 'locationId')
  }, [locations
  ])

  const KEYS_TO_FILTERS = ["responseText", "reviewText", "author", "reviewId"];
  const prepareFinalData = (data) => {
    let cloneData = bindfinalData(data, similarReviews, topicDetails, locationDic);
    let filterData = cloneData;
    // switch (selectedOption) {
    //   case "With Text":
    //     filterData = _.filter(filterData, (a) => a.reviewText != null);
    //     break;
    //   case "Without Text":
    //     filterData = _.filter(filterData, (a) => a.reviewText == null);
    //     break;
    //   case "With Response":
    //     filterData = _.filter(filterData, (a) => a.responseText != null);
    //     break;
    //   case "Without Response":
    //     filterData = _.filter(filterData, (a) => a.responseText == null);
    //     break;
    // }
    if (selectedLocation != "all") {
      filterData = _.filter(
        filterData,
        (a) => a.locationId == selectedLocation
      );
    }
    // if (searchTerm) {
    //   filterData = filterData.filter(createFilter(searchTerm, KEYS_TO_FILTERS));
    // }

    return filterData;
  };
  const suggestedReviewList = useMemo(() => {
    return _.map(suggestionList, (it) => ({
      reviewId: it.entityId,
      reviewText: it.description,
      topicData: it.data,
      ...it,
    }));
  }, [suggestionList, data]);
  const rawData = useMemo(() => {
    return prepareFinalData(
      _.cloneDeep(selectedShowType !== "database" ? suggestedReviewList : data)
    );
  }, [
    data,
    selectedLocation,
    selectedCompany,
    selectedShowType,
    suggestedReviewList,
    similarReviews,
    locationDic
  ]);

  

  const finalData = React.useMemo(() => {
    if (data?.length === 0) {
      return [];
    } else {
      return _.size(sortedReviews) > 0
        ? sortedReviews.filter(createFilter(searchTerm, KEYS_TO_FILTERS))
        : rawData.filter(createFilter(searchTerm, KEYS_TO_FILTERS));
    }
  }, [sortedReviews, searchTerm, data, rawData]);
  //======Reviews Data End=========//
  useEffect(() => {
    if (setFinalReviews) setFinalReviews(finalData);
  }, [finalData]);
  //=====Pagination=====//
  const itemsPerPage = useMemo(() => 50, []);
  const cardTableData = React.useMemo(() => {
    return finalData.slice(
      (reviewsPage - 1) * itemsPerPage,
      reviewsPage * itemsPerPage
    );
  }, [finalData, itemsPerPage, reviewsPage]);

  const startIndexPagination = React.useMemo(() => {
    return (
      finalData.findIndex(
        (item) => item.reviewId === cardTableData[0]?.reviewId
      ) + 1
    );
  }, [reviewsPage, cardTableData, finalData]);
  const endIndexPagination = React.useMemo(() => {
    return (
      finalData.findIndex(
        (item) =>
          item.reviewId === cardTableData[cardTableData.length - 1]?.reviewId
      ) + 1
    );
  }, [reviewsPage, cardTableData, finalData]);
  const handlePaginationChange = (event, value) => {
    setReviewsPage(value);
  };
  //=====Pagination End=====//
  const handleSaveExampleReview = (value) => {
    // setSaveExampleList(prevState => [
    //    ...prevState,
    //    value?.reviewId,
    // ]);
    let data = {
      reviewId: value?.reviewId,
      reviewText: value?.reviewText,
      responseText: value?.responseText,
      companyId: selectedCompany,
    };

    dispatch(
      triggerSaveExampleReview(data, startDate, endDate, selectedCompany)
    );
  };
  const handleDeleteExampleReview = (review) => {
    dispatch(
      triggerDeleteExampleReview(
        review.reviewId,
        review.exampleReviewId,
        review.reviewId,
        startDate,
        endDate,
        selectedCompany
      )
    );
  };
  //===Search=====//
  const handleSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
  };
  //====Search End===//
  //====Use Effects======//
  useEffect(() => {
    setPages(Math.ceil(finalData?.length / itemsPerPage));
  }, [finalData]);
  useEffect(() => {
    setReviewsPage(1);
    setSingleSelectedReview({});
    setSelectedReview && setSelectedReview(null);
  }, [selectedCompany, selectedLocation]);
  useEffect(() => {
    if (isMultiple) {
      setSingleSelectedReview({});
      setSelectedReview && setSelectedReview(null);
    }
  }, [isMultiple]);
  // useEffect(() => {
  //   if (selectedCompany) {
  //     duspatch(fetchInternalLocations(selectedCompany));
  //   }
  // }, [selectedCompany]);
  useEffect(() => {
    if (
      reviewsNumberSelection === "none" &&
      setSelectedReviewIds &&
      setSelectedReviewText && countValue > 0
    ) {
      setSelectedReviewIds([]);
      setSelectedReviewText([]);
    }
  }, [reviewsNumberSelection]);

    const isCurrentPageSelected = useMemo(() => {
    const currentPageReviewIds = _.map(cardTableData, (a) => a.reviewId);
    return currentPageReviewIds.length > 0 && 
           _.every(currentPageReviewIds, (id) => _.includes(selectedReviewIds, id));
  }, [cardTableData, selectedReviewIds]);

  useEffect(()=>{
    if(selectedReviewIds?.length===0){
     setCountValue('')
    }
    if(!isCurrentPageSelected){
      setCountValue('');
      // debugger
    }
    
  },[selectedReviewIds, isCurrentPageSelected]);


  useEffect(() => {
    if (selectedCompany) {
      setSelectedShowType("database");
    }
  }, [selectedCompany]);

  //====Use Effcts End====//
  const handleSelection = (review) => {
    if (singleSelectedReview?.reviewId === review?.reviewId) {
      setSingleSelectedReview({});
      setSelectedReview && setSelectedReview(null);
    } else {
      setSingleSelectedReview(review);
      setSelectedReview && setSelectedReview(review);
    }

    singleSelectFunction(
      review?.reviewId,
      review?.reviewText??'',
      review?.author,
      review
    );
    // setSingleSelectedReview(review);
  }; 
  const handleClick = (event, data) => {
    // setAnchorEl(event.currentTarget);
    setFocusedReview(data);
  };
  const handleClick2 = (event, data) => {
    event.preventDefault()
    event.stopPropagation()
    setAnchorEl2(event.currentTarget);
    setFocusedReview(data);

  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  const deleteInternalReview=()=>{
    dispatch(triggerDeleteInternalReview(focusedReview?.reviewId));
    if ((startDate, endDate)) {
      setTimeout(() => {
        dispatch(fetchReviews(startDate, endDate, selectedCompany));
      }, 1000);
    }
    setFocusedReview({});
    setOpenDeleteWarning(false)
  }
  const handleAction = (action) => {
    if (action == "Delete") {

      // dispatch(triggerDeleteInternalReview(focusedReview?.reviewId));
      // if ((startDate, endDate)) {
      //   setTimeout(() => {
      //     dispatch(fetchReviews(startDate, endDate, selectedCompany));
      //   }, 1000);
      // }
      // setFocusedReview({});
      setOpenDeleteWarning(true)
    }
    setSelectedAction(action);
    handleClose();
  };
  const handleSelectAll = () => {
    const selectedPageData = finalData.slice(
      (reviewsPage - 1) * itemsPerPage,
      reviewsPage * itemsPerPage
    );
    
    const currentPageReviewIds = _.map(selectedPageData, (a) => a.reviewId);
    const currentPageReviewTexts = _.map(selectedPageData, (a) => a.reviewText);
    
    if (isCurrentPageSelected) {
      const updatedSelectedIds = _.difference(selectedReviewIds, currentPageReviewIds);
      const updatedSelectedTexts = _.difference(selectedReviewText, currentPageReviewTexts);
      
      setSelectedReviewIds(updatedSelectedIds);
      setSelectedReviewText(updatedSelectedTexts);
    
      if (updatedSelectedIds.length === 0) {
        setIsSelecting(false);
      }
    } else {
     
      const updatedSelectedIds = _.union(selectedReviewIds, currentPageReviewIds);
      const updatedSelectedTexts = _.union(selectedReviewText, currentPageReviewTexts);
      
      setSelectedReviewIds(updatedSelectedIds);
      setSelectedReviewText(updatedSelectedTexts);
      setIsSelecting(true);
       setCountValue('');
    }
  };

  const handleUnSelectAll = () => {
    if (setSelectedReviewIds && setSelectedReviewText) {
      setSelectedReviewIds([]);
      setSelectedReviewText([]);
      setCountValue('');
     
    }
  };


  
  const selectAllFunc = (e) => {
    const number = e.target.value;
    seReviewsNumberSelection(number);
    if (typeof number !== "string") {
      const reviewList = finalData.slice(0, number);

      if (setSelectedReviewIds && setSelectedReviewText) {
        setSelectedReviewIds(_.map(reviewList, (it) => it.reviewId));
        setSelectedReviewText(_.map(reviewList, (it) => it.reviewText??""));
      }
    } else if (number === "all") {
      if (setSelectedReviewIds && setSelectedReviewText) {
        setSelectedReviewIds(_.map(finalData, (it) => it.reviewId));
        setSelectedReviewText(_.map(finalData, (it) => it.reviewText??''));
      }
    } else if (number === "none" && !isSentiment) {
      if (setSelectedReviewIds && setSelectedReviewText) {
        setSelectedReviewIds([]);
        setSelectedReviewText([]);
      }
    }
  };
  const handleSuggestionList = (e) => {
    const {
      target: { value },
    } = e;
    if (value != "database") {
      dispatch(fetchSuggestionList(value));
    }
    setSelectedShowType(value);
  };
  const handleAddList = (review, isEdit) => {
    setIssueReview(review);
    if (review?.issueListId) {
      setIssueListId(review?.issueListId);
    }
    const topics = review?.topicData;
    if (isEdit) {
      setEditMode(true);
    }
    setIssueData(review?.topicData ? review?.topicData : review?.data);
    setIssueDescription(
      review?.reviewText ? review?.reviewText : review?.description
    );

  };
  const onCloseIssue = () => {
    setOpenIssueModal(false);
    setIssueReview({});
    setIssueListId(null);
    setIssueData(null);
    setIssueDescription(null);
  };
  const onSaveIssue = () => {
    const data = {
      issueType: "Suggestion List",
      entityId: issueReview?.reviewId,
      description: issueDescription,
      data: issueData,
      entityType: "review",
      issueListId: issueListId,
    };
    const editData = {
      issueId: issueReview?.issueId,
      data: issueData,
      description: issueDescription,
    };
    if (editMode) {
      dispatch(
        triggerUpdateIssue(
          editData,
          selectedShowType === "database" ? null : selectedShowType
        )
      );
    } else {
      dispatch(
        triggerCreateIssue(
          data,
          selectedShowType === "database" ? null : selectedShowType
        )
      );
    }
    onCloseIssue();
  };
  const handleListbutton = (review, e) => {
    handleAddList(review);
    setAnchorEl3(e.currentTarget);
    e.stopPropagation();
  };
  const deleteIssue = (e) => {
    e.stopPropagation();
    if (menuReview?.issueId) {
      dispatch(triggerDeleteIssue(menuReview?.issueId, menuReview.issueListId));
      setOpenWarning(false);
    }
  };
  const openwarningModal = () => {
    setOpenWarning(true);
    setAnchorElMenu(null);
  };

  const issueListMenuItems = useMemo(() => {
    const finalArr = []
    finalArr?.push(<ListSubheader sx={{ borderBottom: theme => `1px solid @${theme.palette.divider}`, justifyContent: 'space-between', alignItems: 'center', display: 'flex', gap: '8px' }}><Typography fontWeight={600}>Add to list</Typography>
      <Tooltip title='Manage Lists' arrow disableInteractive><span><IconButton size="small" color='primary' onClick={() => { setIssueListEdit(true); setAnchorEl3(null) }}><SettingsIcon fontSize="small" /></IconButton></span></Tooltip></ListSubheader>)
    const myList = _.sortBy(_.filter(issueList, it => it?.createdBy == userId), 'name')
    if (_.size(myList) > 0) {

      finalArr?.push(<ListSubheader sx={{ lineHeight: '1.3', fontSize: '1rem', textAlign: 'center' }}><Divider>My Lists</Divider></ListSubheader>)
      _.map(myList, (it, index) => finalArr?.push(<MenuItem sx={{ borderTop: theme => index === 0 ? `1px solid black` : '' }} onClick={(e) => { setIssueListId(it.issueListId); setOpenIssueModal(true); setAnchorEl3(null) }} key={it.issueListId} value={it.issueListId}>{it?.name}</MenuItem>))
    }
    const restArr = _.sortBy(_.difference(issueList, myList), 'name')
    _.map(restArr, it => finalArr?.push(<MenuItem onClick={(e) => { setIssueListId(it.issueListId); setOpenIssueModal(true); setAnchorEl3(null) }} key={it.issueListId} value={it.issueListId}>{it?.name}</MenuItem>))
    return finalArr
  }, [issueList])

  const [anchorElSelect, setAnchorElSelect] = useState(null);
  const openSelect = Boolean(anchorElSelect);
  const handleClickSelect = (event) => {
    setAnchorElSelect(event.currentTarget);
  };
  const handleCloseSelect = () => {
    setAnchorElSelect(null);
  };
  useEffect(()=>{
         let onwardCount=0;
          const remainingReviws = _.slice(finalData, startIndexPagination);
          _.forEach(remainingReviws, it => {
            if (_.includes(selectedReviewIds, it.reviewId)) {
              onwardCount = onwardCount + 1
            }
          })
          setCountValue(onwardCount > 0 ? onwardCount+1 : '');
  },[reviewsPage, selectedReviewIds])


const handleSRCountChange = (intValue, page) => {
  // let { value } = e.target;

  // const intValue = Number(value);

  const firstIndex = (page ) * itemsPerPage -itemsPerPage;
  const pageEndIndex = firstIndex + intValue;

  const selectedIds = _.map(
    finalData.slice(firstIndex, pageEndIndex),
    "reviewId"
  );
  const selectedText = _.map(
    finalData.slice(firstIndex, pageEndIndex),
    "reviewText"
  );

  const onwardSlice = finalData.slice(firstIndex, pageEndIndex);
  const onwardIds = _.map(onwardSlice, "reviewId");
  const backwardSlice = finalData.slice(0, firstIndex);
  const backwardIds = _.map(backwardSlice, "reviewId");
  const selectedBackwardIds = _.filter(backwardIds, (id) => _.includes(selectedReviewIds, id));

  const onwardAllIds = _.map(finalData.slice(firstIndex, pageEndIndex), "reviewId");
  if(intValue){

  }
  setSelectedReviewIds(prev => {
    const isCurrentPageSelected = selectedIds.every(id => prev.includes(id));
    const withoutOnward = prev.filter(id => !onwardAllIds.includes(id));

    const keepCurrent = isCurrentPageSelected
      ? _.union(withoutOnward, selectedIds)
      : withoutOnward;

    return _.union(selectedBackwardIds, onwardAllIds);
  });

  const onwardAllText = _.map(finalData.slice(firstIndex, pageEndIndex), "reviewText");
  const selectedBackwardText = _.filter(backwardSlice, (it) => _.includes(selectedReviewText, it.reviewText));
  setSelectedReviewText(prev => {
    const isCurrentPageSelected = selectedText.every(text => prev.includes(text));
    const withoutOnward = prev.filter(text => !onwardAllText.includes(text));

    const keepCurrent = isCurrentPageSelected
      ? _.union(withoutOnward, selectedText)
      : withoutOnward;

    return _.union(selectedBackwardText, onwardAllText);
  });

// debugger
  setCountValue(intValue);
};

const debouncedHandleSRCountChange = useCallback(
  _.debounce(handleSRCountChange, 500), 
  [finalData, selectedReviewIds, selectedReviewText] 
);
const handleOnWardSelection=(e)=>{
  const { value } = e.target;
  setCountValue(value);
  if(value && finalData?.length>0){
    debouncedHandleSRCountChange(_.parseInt(value), reviewsPage)
  }
};
  return (
    <div>
      <Stack
        direction="row"
        spacing={2}
        alignItems={"center"}
        justifyContent={"space-between"}
        pb={0.5}
        mt={1}
        sx={{ flexWrap: "wrap", rowGap: 1 }}
      >
        <Stack direction="row" spacing={2} alignItems={"center"}>
          {isPipeline && (
            <FormControl size="small" sx={{ width: "150px" }}>
              <InputLabel>Show From</InputLabel>
              <Select
                label="Show From"
                size="small"
                value={selectedShowType}
                onChange={handleSuggestionList}
              >
                <MenuItem value="database">{"<Database>"}</MenuItem>
                {_.map(issueList, (it) => (
                  <MenuItem key={it.issueListId} value={it.issueListId}>
                    {it?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {!isSentiment && (
            <>
            <Link
              // variant="outlined"
              color="primary"
              sx={{
                textTransform: "none",
                display: isMultiple ? "" : "none",
                cursor: "pointer",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={handleClickSelect}
            >
              
              {/* {isCurrentPageSelected ? "Unselect" : "Select"} */}
              Select
            </Link>
              <Menu
                id="grouped-menu"
                anchorEl={anchorElSelect}
                open={openSelect}
                onClose={handleCloseSelect}
                slotProps={{
                  list: {
                    'aria-labelledby': 'basic-button',
                    sx: {
                      py: 0,
                    },
                  },
                }}
              >

              
                 <MenuItem onClick={handleSelectAll}
                
                 >{isCurrentPageSelected ? "Unselect " : "Select "}
                   All on this page
                </MenuItem>
                
                <MenuItem onClick={undefined}>
                  <Typography component="span" sx={{ pr: 1 }}>
                    Select
                  </Typography>
                  <TextField
                    value={countValue}
                    onChange={(e) => handleOnWardSelection(e)}
                    type="number"
                    inputProps={{
                      min: 1,
                      maxLength: finalData?.length
                    }}
                    size="small"
                      sx={{ minWidth: "60px", maxWidth: "72px", width: 'auto',
                            '& .MuiInputBase-input': { py: 0.5, px: 1, }
                      }}
                      // label="Count"
                    />
                    <Typography component="span" sx={{ px: 1 }}>
                      reviews from this page onwards
                    </Typography>
                </MenuItem>
                 <MenuItem onClick={handleUnSelectAll}
                   disabled={selectedReviewIds?.length===0}
                 >
                   Unselect All 
                </MenuItem>
              </Menu>
            </>
          )}
          { !isSentiment && _.size(selectedReviewIds) > 1 && (
            <Typography sx={{marginLeft:'3px !important'}}>{`(${(selectedReviewIds?.length).toLocaleString()})`}</Typography>
          )}

          {isSentiment && (
            <FormControl
              size="small"
              sx={{ width: "250px", display: isMultiple ? "" : "none" }}
            >
              <InputLabel sx={{ backgroundColor: theme.palette.background.paper, px: 1 }}>
                Select number of Reviews
              </InputLabel>
              <Select
                size="small"
                onChange={selectAllFunc}
                value={reviewsNumberSelection}
              >
                <MenuItem value={"none"}>Manual</MenuItem>
                <MenuItem value={50}>50 Reviews</MenuItem>
                <MenuItem value={100}>100 Reviews</MenuItem>
                <MenuItem value={150}>150 Reviews</MenuItem>
                <MenuItem value={200}>200 Reviews</MenuItem>
                <MenuItem value={500}>500 Reviews</MenuItem>
                <MenuItem value={"all"}>All Reviews</MenuItem>
              </Select>
            </FormControl>
          )}
        </Stack>
        <Box />
        <Stack direction="row" spacing={1} alignItems="center" pr={2}  sx={{ marginLeft: '0px !important' }}>
          <ReviewSearch
            onSearch={handleSearch}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
          {filters && (
            <Tooltip title={"Filter"} arrow disableInteractive>            
            <ToggleButton
              size="small"
              value="check"
              selected={openCollapse}
              onClick={() => setOpenCollapse((prev) => !prev)}
            >
              <FilterAltIcon />
            </ToggleButton>
            </Tooltip>

          )}
          <ReviewModal
            isSentiment={isSentiment}
            isPrompt={isPrompt}
            setSelectedAction={setSelectedAction}
            startDate={startDate}
            endDate={endDate}
            selectedCompany={selectedCompany}
            setFocusedReview={setFocusedReview}
            selectedLocation={selectedLocation}
          />          
        </Stack>
      </Stack>
      <Divider />
      <div
        style={{
          paddingTop: 16,
          paddingRight: 5,
          height: reviewHeight
            ? `calc(100vh - ${reviewHeight}px)`
            : "calc(100vh - 295px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {filters && (
          <ReviewListFilters
            filterObj={initialReviewFilter}
            filters={filters}
            reviewsData={rawData}
            sortedReviews={finalData}
            setSortedReviews={setSortedReviews}
            setReviewsPage={setReviewsPage}
            openCollapse={openCollapse}
          />
        )}
        <div style={{ overflowY: "scroll", overflowX: "hidden",  paddingRight: 5, }}>
          {_.map(cardTableData, (review, index) => (
            <Box
              key={review.reviewId}
              className={classes.reviewBox}
              aria-label={review.author}
              sx={{
                bgcolor: _.includes(
                  isMultiple ? selectedReviewIds: singleSelectedReview?.reviewId, review?.reviewId
                )
                  ? (theme.palette.mode === 'dark' ? theme.palette.grey[800] : "#EFF8FF")
                  : (theme.palette.mode === 'dark' ? theme.palette.grey[800] : "#FCFCFD"),
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    boxShadow: '0 0px 12px #0000002e !important'
                  },
                  border: '0 !important',
                  boxShadow:  _.includes(
                    isMultiple ? selectedReviewIds: singleSelectedReview?.reviewId, review?.reviewId
                  )
                    ? "0 0px 12px #0000002e !important"
                    : "none !important",
                  borderLeft:  _.includes(
                  isMultiple ? selectedReviewIds: singleSelectedReview?.reviewId, review?.reviewId
                  )
                    ? `5px solid ${theme.palette.primary.main} !important`
                    : `5px solid transparent !important`,
                    transition:'all 0.2s ease-in-out'
                 
              }}
            >
            
              <div
                style={{
                  cursor:  "pointer" ,
                }}
                onClick={() =>
                  handleSelection(review)
                }
              >
                <div className={classes.reviewHeader} style={{alignItems:'flex-start '}}>
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems={"center"}
                    rowGap={1}
                    sx={{flexFlow:'wrap'}}
                  >
                    {getSourceIcon(review?.sourceType,16)}
                    {review?.reviewUpdateTime && (
                      <Tooltip title={moment(new Date(review?.reviewUpdateTime).toLocaleDateString()).format("MM/DD/YYYY hh:mm:ss A [IST]")} arrow disableInteractive>
                        <Typography variant="body2">
                          {new Date(review?.reviewUpdateTime).toLocaleDateString()}
                        </Typography>
                      </Tooltip>
                    )}
                    <Marker variant="body2" mark={searchTerm}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {review?.author && <PersonOutlineIcon sx={{fontSize:'18px', marginTop: '-3px', marginRight: '2px' }}/>}
                        <Typography variant="body2">{review?.author}</Typography>
                      </div>
                    </Marker>
                    <Typography className={classes.rating} variant="subtitle2">
                    {isPipeline && (
                      <MuiChip
                        label={review?.number}
                        sx={{ borderRadius: "50px", mr: 2 }}
                        size="small"
                      />
                    )}
                    {review?.rating && (
                      <>
                        <span style={{ paddingTop: "1px" }}>
                          {"( " + review?.rating}
                        </span>
                        <StarOutlineIcon
                          sx={{
                            fontSize: "0.875rem",
                            mb: "-2px !important",
                          }}
                        />
                        {")"}
                      </>
                    )}
                  </Typography>
                    {review?.locationName && (
                      <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems={"center"}
                      >
                        <LocationOnOutlinedIcon
                          sx={{
                            mt: "-4px !important",
                          }}
                          fontSize="18px"
                        />
                        <Typography variant="body2">
                          {review?.locationName}
                        </Typography>
                      </Stack>
                    )}
                    
                  {review.topicElement}
              
                  </Stack>
                  <Stack direction={"row"} alignItems={"flex-start"} gap={1}>
                   
                    {/* <div style={{ display: "flex" }}>
                      {review?.responseText && !isSentiment && !isPrompt && (
                        <Tooltip
                          title={
                            review?.saveAsExampleReview ? (
                              <span>
                                <span>Already using as a Training Example</span>
                                <br />
                                <span>Click to not use</span>
                              </span>
                            ) : (
                              <span>
                                <span>Not using as Training Example</span>
                                <br />
                                <span>Click to Use</span>
                              </span>
                            )
                          }
                          arrow
                        >
                          <IconButton
                            size="small"
                            aria-label="Smart Toy"  sx={{p:0}}
                            onClick={() =>
                              review?.saveAsExampleReview
                                ? handleDeleteExampleReview(review)
                                : handleSaveExampleReview(review)
                            }
                          >
                            {review?.saveAsExampleReview ? (
                              <SmartToyIcon />
                            ) : (
                              <SmartToyOutlinedIcon sx={{fontSize: '23px !important'}}/>
                            )}
                          </IconButton>
                        </Tooltip>
                      )}
                    </div> */}
                    {/* {selectedShowType === "database" && (
                      <Tooltip title={"Add to list"} arrow disableInteractive>
                        <span>
                          <IconButton sx={{p:0}}
                            onClick={(e) => handleListbutton(review, e)}
                          >
                            <AddCircleOutlineIcon  sx={{fontSize: '18px !important'}}/>
                          </IconButton>
                        </span>
                      </Tooltip>
                    )} */}
                    {review?.sourceType===0&&<Tooltip title={"Edit Review"} arrow disableInteractive><IconButton size="small"
                          aria-label="More Options" 
                          onClick={(e) => { handleClick(e, {
                              sourceId: review.sourceId,
                              reviewId: review.reviewId,
                              authorName: review.author,
                              reviewDate: review.reviewDateTime,
                              rating: review.rating,
                              reviewText: review.reviewText,
                              ...review,
                            }); handleAction("Edit")}}><EditOutlinedIcon sx={{fontSize: '18px !important'}}/></IconButton></Tooltip>}
                    {isPipeline && selectedShowType !== "database" && (
                      <Tooltip title={"More Options"} arrow disableInteractive>
                        <IconButton onClick={(e) => handleClickMenu(e, review)} sx={{p:0}}>
                          <MoreVertIcon sx={{fontSize: '18px !important'}}/>
                        </IconButton>
                      </Tooltip>
                    )}

                    {/* {review?.sourceType === 0 && !isSentiment && !isPrompt &&( */}
                      <div><Tooltip title={"More Details"} arrow disableInteractive>
                        <IconButton
                          size="small"
                          aria-label="More Options"  sx={{p:0}}
                          onClick={(e) => {
                            handleClick(e, {
                              sourceId: review.sourceId,
                              reviewId: review.reviewId,
                              authorName: review.author,
                              reviewDate: review.reviewDateTime,
                              rating: review.rating,
                              reviewText: review.reviewText,
                              ...review,
                            });
                            setOpenMoreDetails(true);
                          }
                          }
                        >
                            <NotesOutlinedIcon sx={{fontSize: '18px !important'}}/>
                        </IconButton>
                      </Tooltip>
                        {/* <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                          sx={{
                            "& .MuiPaper-root": {
                              boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.15)",
                            },
                          }}
                        >
                          
                          {review?.sourceType===0&&<MenuItem onClick={() => handleAction("Delete")}>
                            Delete
                          </MenuItem>}
                          <MenuItem onClick={() => setOpenMoreDetails(true)}>
                            More Details
                          </MenuItem>
                        </Menu>
                      */}
                      </div>
                     {/* )} */}
                    {/* {review?.sourceType !== 0 && (
                      <div>

                        <IconButton
                          size="small"
                          aria-label="More Options"  sx={{p:0}}
                          onClick={(e) =>
                            handleClick2(e, {
                              sourceId: review.sourceId,
                              reviewId: review.reviewId,
                              authorName: review.author,
                              reviewDate: review.reviewDateTime,
                              rating: review.rating,
                              reviewText: review.reviewText,
                              ...review,
                            })
                          }
                        >
                          <MoreVertIcon sx={{fontSize: '20px !important'}}/>
                        </IconButton>
                        <Menu
                          slotProps={{
                            paper: {
                              sx: {
                                boxShadow: "none",
                                border: "1px solid rgba(0,0,0,0.12)",
                              },
                            },
                          }}
                          anchorEl={anchorEl2}
                          open={Boolean(anchorEl2)}
                          onClose={handleClose2}
                        >
                          <MenuItem onClick={() => handleAction("Edit")}>
                            Edit
                          </MenuItem>
                          <MenuItem
                            onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              setOpenMoreDetails(true);
                              handleClose2();
                            }}
                          >
                            More Details
                          </MenuItem>
                        </Menu>
                      </div>
                    )} */}
                  </Stack>
                </div>
                {/* <Stack direction={"row"} spacing={2} alignItems={"center"}>
                 

                  {review.topicElement}
                </Stack> */}
                <ReviewItem
                  key={index}
                  review={review}
                  searchTerm={searchTerm}
                  selectedShowType={selectedShowType}
                  handleAddList={handleAddList}
                />
              </div>
            </Box>
          ))}
        </div>
        <Stack
          direction={"row"}
          spacing={2}
          justifyContent="space-between"
          sx={{
            // pt: { xl: 2, lg: 0.5 },
            position: "sticky",
            bottom: 0,
            backgroundColor: "background.paper",
            zIndex: 1,
            borderTop: (theme) => `1px solid ${theme.palette.divider}`,
            ml: '-16px',
            p: '8px 0px 8px 6px'
          }}
          alignItems={"center"}
        >
          {cardTableData.length > 0 &&
            startIndexPagination &&
            endIndexPagination && (
              <Typography fontWeight={600}>
                {startIndexPagination} - {endIndexPagination}{" "}
                {"of " + finalData?.length + " Reviews"}
              </Typography>
            )}
          {cardTableData.length > 0 && (
            <Pagination
              count={noOfPages}
              onChange={handlePaginationChange}
              page={reviewsPage}
              color="primary"
              variant={"combined"}
              siblingCount={0}
              showFirstButton={true}
              showLastButton={true}
            />
          )}
        </Stack>
      </div>
      {isPipeline && (
        <Menu
          id="basic-menu"
          anchorEl={anchorElMenu}
          open={open}
          onClose={handleCloseMenu}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => { setOpenMoreDetails(true); handleCloseMenu() }}>
            More Details
          </MenuItem>
          <MenuItem onClick={(e) => { handleAddList(menuReview, true); setOpenIssueModal(true); handleCloseMenu() }}>
            Edit
          </MenuItem>
          <MenuItem onClick={openwarningModal}>Remove from list</MenuItem>
        </Menu>
      )}
      {openIssueModal && (
        <CreateIssue
          openIssueModal={openIssueModal}
          onCloseIssue={onCloseIssue}
          setIssueData={setIssueData}
          issueData={issueData}
          issueDescription={issueDescription}
          setIssueDescription={setIssueDescription}
          issueList={issueList}
          issueListId={issueListId}
          setIssueListId={setIssueListId}
          onSaveIssue={onSaveIssue}
          menuReview={menuReview}
          isEdit={editMode}
        />
      )}
      {isPipeline && openWarning && (
        <Dialog open={openWarning} onClose={() => setOpenWarning(false)}>
          <DialogTitle>Remove Internal Review?</DialogTitle>
          <DialogContent>
            Are you sure you want to remove the issue from the list, this action
            cannot be undone.
          </DialogContent>
          <DialogActions sx={{ display: "flex", gap: "16px", px: 2, pb: 2 }}>
          
            <Button
              color="error"
              variant="contained"
              onClick={deleteIssue}
              fullWidth
            >
              Yes,remove
            </Button>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => setOpenWarning(false)}
              fullWidth
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      { openDeleteWarning && (
        <Dialog open={openDeleteWarning} onClose={() => setOpenDeleteWarning(false)}>
          <DialogTitle>Remove Issue from list?</DialogTitle>
          <DialogContent>
            Are you sure you want to remove the internal review? This action
            cannot be undone.
          </DialogContent>
          <DialogActions sx={{ display: "flex", gap: "16px", px: 2, pb: 2 }}>
          
            <Button
              color="error"
              variant="contained"
              onClick={deleteInternalReview}
              fullWidth
            >
              Yes,remove
            </Button>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => setOpenDeleteWarning(false)}
              fullWidth
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openMoreDetails && (
        <MoreDetails
          open={openMoreDetails}
          reviewId={focusedReview?.reviewId}
          review={focusedReview}
          selectedCompany={selectedCompany}
          handleClose={() => setOpenMoreDetails(false)}
          size="lg"
        />
      )}
      {selectedAction == "Edit" && focusedReview && (
        <ReviewModal
          isSentiment={isSentiment}
          isPrompt={isPrompt}
          reviewData={focusedReview}
          setSelectedAction={setSelectedAction}
          startDate={startDate}
          endDate={endDate}
          selectedCompany={selectedCompany}
          setFocusedReview={setFocusedReview}
          selectedLocation={selectedLocation}
          handleDelete={() => handleAction("Delete")}
        />
      )}
      <Menu
        anchorEl={anchorEl3}
        open={Boolean(anchorEl3)}
        onClose={() => setAnchorEl3(null)}
      >
        {/* {_.map(issueList, (it) => (
          <MenuItem
            onClick={(e) => {
              setIssueListId(it.issueListId);
              setOpenIssueModal(true);
              setAnchorEl3(null);
            }}
            key={it.issueListId}
            value={it.issueListId}
          >
            {it?.name}
          </MenuItem>
        ))} */}
        {issueListMenuItems}
      </Menu>
      {issueListEdit && <IssueEditDetails open={issueListEdit} handleClose={() => { setIssueListEdit(false); setAnchorEl3(null) }} selectedCompany={selectedCompany} />}
    </div>
  );
};

export default Index;
